var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99922 48H2.19922C1.09922 48 0.199219 47.1 0.199219 46V38C0.199219 36.9 1.09922 36 2.19922 36H9.99922C11.0992 36 11.9992 36.9 11.9992 38V46C11.9992 47.1 11.0992 48 9.99922 48Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 48H38C36.9 48 36 47.1 36 46V38C36 36.9 36.9 36 38 36H45.8C46.901 36 47.8 36.9 47.8 38V46C47.8 47.1 46.9 48 45.8 48Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3 12H20.5C19.4 12 18.5 11.1 18.5 10V2C18.5 0.9 19.4 0 20.5 0H28.3C29.401 0 30.3 0.9 30.3 2V10C30.3 11.1 29.4 12 28.3 12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16V24",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 32.2004V25.9004C6.09961 24.7994 6.99961 23.9004 8.09961 23.9004H39.8996C40.9996 23.9004 41.8996 24.8004 41.8996 25.9004V32.1004",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopo);
export default __webpack_public_path__ + "static/media/topo.f77af3df1e111b00188495e889dffec6.svg";
export { ForwardRef as ReactComponent };